import Backend from "./Backend";
import {selectedCompanyStore} from "../store/SelectedCompany";


export const uploadFile = (sessionId: string, fileName: string, base64FileBody: string): Promise<void> => {
    const companyId = selectedCompanyStore.companyId;
    return Backend.post(`/api/v1/company/${companyId}/file/upload/${sessionId}`, {
        name: fileName,
        file: base64FileBody,
    });
}